import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { PaymentDetails } from '~/types';
import { cleanupFormValues } from '~/utils';
import PaymentDetailsForm from './PaymentDetailsForm';
import { FormDrawer } from '~/components';
import { paymentDetails } from '~/routes';
import { usePermissions } from '~/hooks';
import { usePaymentDetailsCreate } from '~/hooks/paymentDetails';

const PaymentDetailsCreate: FC = () => {
  const [t] = useTranslation('paymentDetails');

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate } = usePaymentDetailsCreate(handleClose);
  const onFinish = (values: PaymentDetails) => {
    mutate(cleanupFormValues(values));
  };

  const hasAccess = usePermissions('business.paymentDetails.create');
  if (!hasAccess) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {t('addPaymentDetails')}
      </Button>
      <FormDrawer
        name={paymentDetails}
        onFinish={onFinish}
        title={t('addPaymentDetails')}
        onClose={handleClose}
        visible={open}
      >
        <PaymentDetailsForm name={paymentDetails} />
      </FormDrawer>
    </>
  );
};

export default PaymentDetailsCreate;
